import { ArticleHeaderContainer } from "../../components/Header";
import WizardButton from "./WizardButton";

const ReportWizardSteps = ({ wizardButtons, isNavigating }) => {
  return (
    <ArticleHeaderContainer>
      {Array.isArray(wizardButtons)
        ? wizardButtons.map((item, idx) => (
            <WizardButton
              key={`${item?.caption}-${idx}`}
              {...item}
              step={idx + 1}
              length={wizardButtons?.length}
              disabled={item.disabled || isNavigating}
            />
          ))
        : null}
    </ArticleHeaderContainer>
  );
};

export default ReportWizardSteps;
